var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.403 12.4579V6.5237H12.8944V0.589478H6.02269V6.5237H1.597V12.4579H0V15.4104H16V12.4579H14.403ZM13.4655 7.4612V12.4579H8.46875V7.4612H9.50166V9.50979H12.4326V7.4612H13.4655ZM10.4392 7.4612H11.4951V8.57229H10.4392V7.4612ZM8.93056 1.52698H9.9865V2.63807H8.93056V1.52698ZM6.96019 1.52698H7.99309V3.5756H10.924V1.52698H11.9569V6.5237H6.96019V1.52698ZM4.50491 7.4612H5.56084V8.57229H4.50491V7.4612ZM2.5345 7.4612H3.56741V9.50979H6.49834V7.4612H7.53125V12.4579H2.5345V7.4612ZM15.0625 14.4729H0.9375V13.3954H15.0625V14.4729Z",
    fill: "#3F4752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.e01cbc0c782ffd30527a03c614d649f3.svg";
export { ForwardRef as ReactComponent };